export enum UrlType {
  Url = 'Url',
  Path = 'Path',
  Query = 'Query',
}

export default function mod({
  url,
  type = UrlType.Url,
  includeOrigin = true,
  includePath = true,
  includeQuery = true,
  includeParams = undefined,
  excludeParams = undefined,
}:
{
  url: string
  type?: UrlType
  includeOrigin?: boolean
  includePath?: boolean
  includeQuery?: boolean
  includeParams?: undefined | string[]
  excludeParams?: undefined | string[]
} = {}) {
  let origin
  let path
  let query
  switch (type) {
    case UrlType.Url:
      const urlObj = new URL(url)
      origin = urlObj.origin
      path = urlObj.pathname
      query = urlObj.search
      break
    case UrlType.Path:
      origin = ''
      path = url.split('?')[0] || ''
      query = url.split('?')[1] || ''
      break
    case UrlType.Query:
      origin = ''
      path = ''
      query = url
      break
  }
  if (includeParams || excludeParams) {
    const searchParams = new URLSearchParams(query)
    if (includeParams) {
      const uniqueParamKeys = [...new Set(Array.from(searchParams.keys()))]
      uniqueParamKeys.forEach((param) => {
        if (!includeParams.includes(param))
          searchParams.delete(param)
      })
    }
    if (excludeParams?.length) {
      excludeParams.forEach((param) => {
        if (searchParams.has(param))
          searchParams.delete(param)
      })
    }
    query = `?${searchParams.toString()}`
  }
  return `${
    includeOrigin ? origin : ''
  }${
    includePath ? path : ''
  }${
    includeQuery ? query : ''
  }`
}
